import { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { duration, ease } from '../../../theme/tokens';

const Stage = styled.div<{ $in: boolean }>`
  opacity: ${({ $in }) => ($in ? 1 : 0)};
  transform: ${({ $in }) => ($in ? 'none' : 'translate3d(0, 18px, 0)')};
  transition:
    opacity ${duration.slow} ${ease.out},
    transform ${duration.slow} ${ease.out};

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    transform: none;
    transition: none;
  }
`;

/**
 * Fades and lifts the page on every route change, and returns the scroll
 * position to the top so a new route never starts mid-page.
 */
const PageTransition = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    setEntered(false);
    window.scrollTo({ top: 0, behavior: 'auto' });
    const raf = requestAnimationFrame(() => setEntered(true));
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return <Stage $in={entered}>{children}</Stage>;
};

export default PageTransition;
